export default "__VITE_ASSET__9Nzk77sZ__"